import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

/**
 * Tracks the Socket.IO connection lifecycle
 * (docs/architecture/frontend-architecture.md lists "Socket Connection" as
 * a client responsibility, and Theme/Socket/Authentication as the three
 * things that belong in global state). No socket client dispatches into
 * this yet — `socket.io-client` isn't installed, and there's no messaging
 * feature to connect on behalf of. The slice is real and complete on its
 * own terms (correct state shape, correct transitions); it has a consumer
 * once `features/messaging` exists, the same way `auth` has a consumer
 * once the identity feature exists.
 */
export type SocketStatus = "disconnected" | "connecting" | "connected" | "error";

export interface SocketState {
  status: SocketStatus;
}

const initialState: SocketState = {
  status: "disconnected",
};

const socketSlice = createSlice({
  name: "socket",
  initialState,
  reducers: {
    setSocketStatus: (state, action: PayloadAction<SocketStatus>) => {
      state.status = action.payload;
    },
  },
});

export const { setSocketStatus } = socketSlice.actions;
export default socketSlice.reducer;
